'use strict';
import uniqueId from 'lodash/utility/uniqueId';

export default class NotificationStore {

    constructor() {
        this.bindActions(this.alt.getActions('notifications'));
        this.notifications = [];
    }

    onAddSuccessNotification(notifications) {
        var notificationIds = [];
        notifications = !Array.isArray(notifications) ? [notifications] : notifications;
        notifications = notifications.map((notification) => {
            notification.id = uniqueId('notification_');
            notificationIds.push(notification.id);
            return notification;
        });

        this.notifications = this.notifications.concat(notifications);
        setTimeout(() => {
            this.alt.getActions('notifications').removeNotification(notificationIds);
        }, 2500);
    }

    onAddErrorNotification(data) {
        // var {mediaIds, basketName} = data;
        // mediaIds.forEach((mediaId) => {
        //     var id = uniqueId('notification_');
        //     this.notifications.push({
        //         id: id,
        //         mediaId: mediaId,
        //         basketName: basketName,
        //         type: 'error'
        //     });
        //     this.alt.getActions('notifications').removeNotification(id);
        // });

    }

    removeNotification(ids) {
        ids = !Array.isArray(ids) ? [ids] : ids;
        this.notifications = this.notifications.filter((notification) => {
            return ids.indexOf(notification.id) === -1;
        });
    }

}



// WEBPACK FOOTER //
// ./app/stores/notificationStore.js